import http from '@/utils/http'
export const getUser = data => http.get('/user-center/api/user', {
    params: data
})
export const addUser = data => http.post('/user-center/api/user', data)
export const editUser = data => http.put('/user-center/api/user', data)
export const delUser = data => http.delete('/user-center/api/user', {
    params: data
})
export const ChangeUserEmail = data => http.put('/user-center/api/user/enable', data)
export const exportUser = data => http.get('/user-center/api/user/excel', {
    params: data,
    responseType: 'blob'
})
export const changePssword = data => http.put('/user-center/api/user/password', data)
// 密码重置
export const resetPssword = data => http.post('/user-center/api/user/resetpwd', data)
export default {
    getUser,
    addUser,
    delUser,
    editUser,
    ChangeUserEmail,
    exportUser,
    changePssword,
    resetPssword

}